export function SpacerWidget({ id }: { id: string }) {
  return <div className="spacer-widget" data-grid-id={id} />;
}
